// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExtendedUsers__list-f43f41 {
  flex: 1;
}

.ExtendedUsers__placeholders-e2c5b8 {
  padding: 8px 24px;
}

.ExtendedUsers__more-people-f16e56 {
  margin-top: 32px;
  margin-bottom: 10px;
  margin-inline-start: 24px;
  color: var(--base-70);
  font: var(--font-subtitle-1);
  letter-spacing: var(--font-spacing-subtitle-1);
}`, "",{"version":3,"sources":["webpack://./src/components/SelectContacts/Users/ExtendedUsers/ExtendedUsers.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF","sourcesContent":[".list {\n  flex: 1;\n}\n\n.placeholders {\n  padding: 8px 24px;\n}\n\n.more-people {\n  margin-top: 32px;\n  margin-bottom: 10px;\n  margin-inline-start: 24px;\n  color: var(--base-70);\n  font: var(--font-subtitle-1);\n  letter-spacing: var(--font-spacing-subtitle-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `ExtendedUsers__list-f43f41`,
	"placeholders": `ExtendedUsers__placeholders-e2c5b8`,
	"more-people": `ExtendedUsers__more-people-f16e56`,
	"morePeople": `ExtendedUsers__more-people-f16e56`
};
module.exports = ___CSS_LOADER_EXPORT___;
